import React, {Component} from 'react';
import ReportMovimentiView from './ReportMovimentiView'
import ReportMovimentiViewEc from './ReportMovimentiViewEc'
import ReportMovimentiViewCommesse from './ReportMovimentiViewCommesse'

class ReportMovimentiViewSwitcher extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0
        };
    }

    changeTab(tabnum){
        this.setState({activeTab: tabnum})
    }

    render() {
        let currView = null;
        if (this.state.activeTab === 0){
            currView = <ReportMovimentiView {...this.props} />
        }
        else if (this.state.activeTab === 1){
            currView = <ReportMovimentiViewEc {...this.props} />
        }
        else {
            currView = <ReportMovimentiViewCommesse {...this.props} />
        }

        return <div>
            <div className="ui top attached tabular menu">
                <a className={this.state.activeTab === 0 ? "item active": "item"} onClick={()=>(this.changeTab(0))} >Movimenti per PDC</a>
                <a className={this.state.activeTab === 1 ? "item active": "item"} onClick={()=>(this.changeTab(1))}>Movimenti per EC</a>
                <a className={this.state.activeTab === 2 ? "item active": "item"} onClick={()=>(this.changeTab(2))}>Movimenti per Commessa</a>
            </div>
            <div className="ui bottom attached tab segment active">
                {currView}
            </div>
        </div>

    }
}



export default ReportMovimentiViewSwitcher;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportMovimentiViewSwitcher.js
 **/